import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import { upload } from 'fetchers/upload.fetchers';

export const uploadFile = async (
  file: File,
  orgId: number,
  cb: (progress: number) => void,
): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const data = await upload(formData, orgId, {
      onUploadProgress: (progressEvent: ProgressEvent) => {
        const { loaded, total } = progressEvent;
        const percent = Math.floor((loaded * 100) / total);

        if (percent <= 100) {
          cb(percent);
        }
      },
    });

    return data?.url;
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }
    throw error;
  }
};
